module.exports = __webpack_public_path__ + "static/media/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.4ef866b5.mp3";